module.exports = __webpack_public_path__ + "img/process.e1039a1b.png";